"use client";

import * as React from "react";
import { cn } from "./cn";

type Props = {
  title: React.ReactNode;
  meta?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
  className?: string;
};

export function Accordion({ title, meta, defaultOpen = false, children, className }: Props) {
  const [open, setOpen] = React.useState(defaultOpen);
  const panelId = React.useId();
  return (
    <div
      className={cn(
        "bg-card text-card-foreground rounded-card border transition-colors",
        open ? "border-accent/40" : "border-border/60 hover:border-foreground/15",
        className,
      )}
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-controls={panelId}
        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left rounded-card"
      >
        <span className="flex-1 min-w-0">
          <div className="flex items-baseline gap-3 flex-wrap">
            <span className="font-display font-semibold text-[17px] leading-6 text-foreground">
              {title}
            </span>
            {meta ? <span className="text-xs text-muted-foreground">{meta}</span> : null}
          </div>
        </span>
        <span
          aria-hidden
          className={cn(
            "text-foreground/40 transition-transform shrink-0",
            open ? "rotate-180 text-accent" : null,
          )}
        >
          ▾
        </span>
      </button>
      {open ? (
        <div id={panelId} className="px-5 pb-5 pt-1 border-t border-border/60">
          {children}
        </div>
      ) : null}
    </div>
  );
}
